// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1eIKO","location":"Header_location__3w5er"};